module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.showModalPf) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "Modal"
    }
  }, [_c('div', {
    staticClass: "modal",
    staticStyle: {
      "height": "580px",
      "width": "750px"
    },
    attrs: {
      "role": "dialog",
      "aria-labelledby": "modalTitle",
      "aria-describedby": "modalDescription"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "typepf_reset"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_c('label', [_vm._v("Type Of Function")]), _vm._v(" "), _c('treeselect', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "--Choose a Function--",
      "multiple": false,
      "options": _vm.categories
    },
    on: {
      "select": _vm.filterPf
    },
    model: {
      value: (_vm.currentStoredValue),
      callback: function($$v) {
        _vm.currentStoredValue = $$v
      },
      expression: "currentStoredValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_c('label', [_vm._v("Function")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "415px"
    },
    on: {
      "change": _vm.getDescription
    },
    model: {
      value: (_vm.functionName),
      callback: function($$v) {
        _vm.functionName = $$v
      },
      expression: "functionName"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select a Function--")]), _vm._v(" "), _vm._l((_vm.selectedCategory), function(each, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": each.function_name
      }
    }, [_vm._v("\n                  " + _vm._s(each.alias) + "\n                  ")])
  })], 2)], 1), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stagetype === _vm.stageTypes.traditional),
      expression: "stagetype === stageTypes.traditional"
    }],
    staticClass: "row",
    staticStyle: {
      "margin-top": "7px",
      "width": "450px",
      "margin-left": "15px"
    }
  }, [(_vm.functionName) ? _c('div', {
    staticClass: "component-style"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse",
    attrs: {
      "id": "content-pf-description"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "height": "135px",
      "white-space": "break-spaces",
      "overflow-y": "auto"
    }
  }, [_vm._v(_vm._s(_vm.functionDescription))])])]) : _vm._e(), _vm._v(" "), (_vm.functionName === 'navigateToNextStageBasedOnAgeRange') ? _c('div', {
    staticClass: "input_age"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-rounded btn-ageinput",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addAgeRange
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" Age Group \n           ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ageList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "age-container"
    }, [_c('div', [(_vm.functionName === 'navigateToNextStageBasedOnAgeRange') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ageLowerLimit),
        expression: "item.ageLowerLimit"
      }],
      staticClass: "form-control",
      class: {
        'form-group--error': _vm.submitted && _vm.functionName === 'navigateToNextStageBasedOnAgeRange' && (!_vm.$v.ageList.$each[index].ageLowerLimit.required || !_vm.$v.ageList.$each[index].ageLowerLimit.maxValue || !_vm.$v.ageList.$each[index].ageLowerLimit.minValue || !_vm.$v.ageList.$each[index].ageLowerLimit.numeric || item.ageLowerLimit === item.ageUpperLimit)
      },
      staticStyle: {
        "width": "75%",
        "height": "35px"
      },
      attrs: {
        "type": "text",
        "placeholder": "Age input (From)"
      },
      domProps: {
        "value": (item.ageLowerLimit)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ageLowerLimit", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.submitted && _vm.functionName === 'navigateToNextStageBasedOnAgeRange' && (!_vm.$v.ageList.$each[index].ageLowerLimit.required || !_vm.$v.ageList.$each[index].ageLowerLimit.minValue || !_vm.$v.ageList.$each[index].ageLowerLimit.maxValue || !_vm.$v.ageList.$each[index].ageLowerLimit.numeric || item.ageLowerLimit === item.ageUpperLimit)) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter correct age.")]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.functionName === 'navigateToNextStageBasedOnAgeRange') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ageUpperLimit),
        expression: "item.ageUpperLimit"
      }],
      staticClass: "form-control",
      class: {
        'form-group--error': _vm.submitted && _vm.functionName === 'navigateToNextStageBasedOnAgeRange' && (!_vm.$v.ageList.$each[index].ageUpperLimit.required || !_vm.$v.ageList.$each[index].ageUpperLimit.minValue || !_vm.$v.ageList.$each[index].ageUpperLimit.maxValue || !_vm.$v.ageList.$each[index].ageUpperLimit.numeric ||
          item.ageUpperLimit < item.ageLowerLimit || item.ageLowerLimit === item.ageUpperLimit)
      },
      staticStyle: {
        "width": "75%",
        "height": "35px"
      },
      attrs: {
        "type": "text",
        "placeholder": "Age input (To)"
      },
      domProps: {
        "value": (item.ageUpperLimit)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ageUpperLimit", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.submitted && _vm.functionName === 'navigateToNextStageBasedOnAgeRange' && (!_vm.$v.ageList.$each[index].ageUpperLimit.required || !_vm.$v.ageList.$each[index].ageUpperLimit.maxValue || !_vm.$v.ageList.$each[index].ageUpperLimit.minValue || !_vm.$v.ageList.$each[index].ageUpperLimit.numeric || item.ageUpperLimit < item.ageLowerLimit || item.ageLowerLimit === item.ageUpperLimit)) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter correct age.")]) : _vm._e()]), _vm._v(" "), (_vm.functionName === 'navigateToNextStageBasedOnAgeRange') ? _c('div', {
      staticClass: "remove-group-btn-container"
    }, [_c('button', {
      staticClass: "btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2",
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeGroup(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()])
  }), _vm._v(" "), (_vm.functionName === 'navigateBasedOnKeyword') ? _c('NavigateToNextStageBasedOnKeyword', {
    ref: "keywordMappingValidationComponent",
    attrs: {
      "conversationOptions": _vm.conversationOptions,
      "allKeywords": _vm.allKeywords,
      "keywordMappingList": _vm.keywordMappingList
    },
    on: {
      "add-keyword-mapping": _vm.handleAddKeywordMapping,
      "update-keyword-mapping-list": _vm.handleUpdateKeywordConvoMapping
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-conversation"
  }, [(_vm.functionName === 'navigateToNextStageFromAnswer') ? _c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && _vm.functionName === 'navigateToNextStageFromAnswer' && !_vm.$v.selectedconversation.required
    },
    attrs: {
      "placeholder": "Select conversation",
      "multiple": false,
      "options": _vm.conversationOptions
    },
    on: {
      "input": _vm.getStages
    },
    model: {
      value: (_vm.selectedconversation),
      callback: function($$v) {
        _vm.selectedconversation = $$v
      },
      expression: "selectedconversation"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.conversationNotExistError && _vm.functionName === 'navigateToNextStageFromAnswer') ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v(" Please select valid conversation ")]) : _vm._e(), _vm._v(" "), (_vm.submitted && _vm.functionName === 'navigateToNextStageFromAnswer' && !_vm.$v.selectedconversation.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose conversation.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "input-stage"
  }, [(_vm.functionName === 'navigateToNextStageFromAnswer') ? _c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && _vm.functionName === 'navigateToNextStageFromAnswer' && !_vm.$v.stageSelected.required
    },
    attrs: {
      "placeholder": "Select stage",
      "multiple": false,
      "options": _vm.stageOptions
    },
    on: {
      "input": _vm.getOptions
    },
    model: {
      value: (_vm.stageSelected),
      callback: function($$v) {
        _vm.stageSelected = $$v
      },
      expression: "stageSelected"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.submitted && _vm.functionName === 'navigateToNextStageFromAnswer' && !_vm.$v.stageSelected.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose stage.")]) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.functionName === 'navigateToNextStageFromScoreRank') ? _c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && _vm.functionName === 'navigateToNextStageFromScoreRank' && !_vm.$v.scoredResponseSelected.required
    },
    attrs: {
      "placeholder": "Select Conversation",
      "multiple": false,
      "options": _vm.scoredResponseConversationOptions
    },
    on: {
      "input": _vm.getOptionsForScoredResponse
    },
    model: {
      value: (_vm.scoredResponseSelected),
      callback: function($$v) {
        _vm.scoredResponseSelected = $$v
      },
      expression: "scoredResponseSelected"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.conversationNotExistError && _vm.functionName === 'navigateToNextStageFromScoreRank') ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v(" Please select valid conversation ")]) : _vm._e(), _vm._v(" "), (_vm.submitted && _vm.functionName === 'navigateToNextStageFromScoreRank' && !_vm.$v.scoredResponseSelected.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose conversation.")]) : _vm._e()], 1), _vm._v(" "), (_vm.isInputRequired) ? _c('div', {
    staticClass: "row"
  }, [((_vm.functionName === 'navigateToNextStageBasedOnUsersLocation' || _vm.functionName === 'navigateToNextStageBasedOnUsersLocationSubstring')) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "width": "660px",
      "margin-bottom": "20px",
      "margin-top": "-20px"
    }
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && (_vm.functionName === 'navigateToNextStageBasedOnUsersLocation' || _vm.functionName === 'navigateToNextStageBasedOnUsersLocationSubstring') && !_vm.$v.locationType.required
    },
    model: {
      value: (_vm.locationType),
      callback: function($$v) {
        _vm.locationType = $$v
      },
      expression: "locationType"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select type of Location--")]), _vm._v(" "), _vm._l((_vm.locationOptions), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": data.value
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), (_vm.submitted && (_vm.functionName === 'navigateToNextStageBasedOnUsersLocation' || _vm.functionName === 'navigateToNextStageBasedOnUsersLocationSubstring') && !_vm.$v.locationType.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose the type of location.")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('label', [_vm._v("Input")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.functionInput),
      expression: "functionInput"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': (_vm.submitted && !_vm.$v.functionInput.required)
    },
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Function Input"
    },
    domProps: {
      "value": (_vm.functionInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.functionInput = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.functionInput.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter input.")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.functionName === 'fetchValueBasedOnSelectedDemographic') ? _c('div', [_c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && _vm.functionName === 'fetchValueBasedOnSelectedDemographic' && !_vm.$v.demographicValue.required
    },
    attrs: {
      "placeholder": "--Choose an Option--",
      "multiple": false,
      "options": _vm.demographicOptions
    },
    on: {
      "input": _vm.updateValue
    },
    model: {
      value: (_vm.demographicValue),
      callback: function($$v) {
        _vm.demographicValue = $$v
      },
      expression: "demographicValue"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.submitted && _vm.functionName === 'fetchValueBasedOnSelectedDemographic' && !_vm.$v.demographicValue.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose an option.")]) : _vm._e(), _vm._v(" "), (_vm.functionName === 'setImplicitReferrals') ? _c('div', [_c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.referralValues.required
    },
    attrs: {
      "placeholder": "--Choose an Option--",
      "multiple": true,
      "async": true,
      "defaultOptions": true,
      "load-options": _vm.loadOptions,
      "cacheOptions": false
    },
    model: {
      value: (_vm.referralValues),
      callback: function($$v) {
        _vm.referralValues = $$v
      },
      expression: "referralValues"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.submitted && !_vm.$v.referralValues.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a Referral(s).")]) : _vm._e(), _vm._v(" "), (_vm.functionName === 'checkUserHaveSpecificReferral') ? _c('div', [_c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.selectedReferralType.required
    },
    attrs: {
      "placeholder": "--Choose referral type--",
      "defaultOptions": true,
      "options": _vm.specificReferralTypes
    },
    model: {
      value: (_vm.selectedReferralType),
      callback: function($$v) {
        _vm.selectedReferralType = $$v
      },
      expression: "selectedReferralType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.submitted && !_vm.$v.selectedReferralType.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a referral type.")]) : _vm._e(), _vm._v(" "), (_vm.functionName === 'checkIfResourceExistNearUserLocation') ? _c('div', {
    staticStyle: {
      "width": "600px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "gap": "10px",
      "margin-bottom": "16px"
    }
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Location Type")]), _vm._v(" "), _c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.selectedLocationType.required
    },
    attrs: {
      "placeholder": "--Choose location type--",
      "defaultOptions": true,
      "options": _vm.locationTypes
    },
    model: {
      value: (_vm.selectedLocationType),
      callback: function($$v) {
        _vm.selectedLocationType = $$v
      },
      expression: "selectedLocationType"
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.selectedLocationType.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a location type.")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Distance From User")]), _vm._v(" "), _c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.selectedKmDistance.required
    },
    attrs: {
      "options": _vm.kmDistanceOptions,
      "placeholder": "Select a number",
      "clearable": true,
      "searchable": false
    },
    model: {
      value: (_vm.selectedKmDistance),
      callback: function($$v) {
        _vm.selectedKmDistance = $$v
      },
      expression: "selectedKmDistance"
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.selectedKmDistance.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a distance from user.")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.selectedKmDistance.required
    },
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Services")])]), _vm._v(" "), (_vm.submitted && !_vm.$v.selectedOfferings.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please select the service or product.")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline padding-botton-15px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelectedServices),
      expression: "allSelectedServices"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelectedServices) ? _vm._i(_vm.allSelectedServices, null) > -1 : (_vm.allSelectedServices)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.allSelectedServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelectedServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allSelectedServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelectedServices = $$c
        }
      }, function($event) {
        return _vm.selectAllServices('service')
      }]
    }
  }), _vm._v(" Select All")]), _vm._v(" "), _vm._l((_vm.servicesList), function(service) {
    return _c('div', {
      key: service.id
    }, [_c('label', {
      staticClass: "checkbox-inline",
      staticStyle: {
        "display": "inline-table"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedOfferings),
        expression: "selectedOfferings"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": service.id,
        "checked": Array.isArray(_vm.selectedOfferings) ? _vm._i(_vm.selectedOfferings, service.id) > -1 : (_vm.selectedOfferings)
      },
      on: {
        "click": function($event) {
          return _vm.selectService('service')
        },
        "change": function($event) {
          var $$a = _vm.selectedOfferings,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = service.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedOfferings = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedOfferings = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedOfferings = $$c
          }
        }
      }
    }), _vm._v(_vm._s(service.legacy_name) + "\n                      ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.selectedKmDistance.required
    },
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Products")])]), _vm._v(" "), (_vm.submitted && !_vm.$v.selectedOfferings.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please select the service or product.")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline padding-botton-15px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelectedProducts),
      expression: "allSelectedProducts"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelectedProducts) ? _vm._i(_vm.allSelectedProducts, null) > -1 : (_vm.allSelectedProducts)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.allSelectedProducts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelectedProducts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allSelectedProducts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelectedProducts = $$c
        }
      }, function($event) {
        return _vm.selectAllServices('product')
      }]
    }
  }), _vm._v(" Select All")]), _vm._v(" "), _vm._l((_vm.productList), function(data) {
    return _c('div', {
      key: data.id
    }, [_c('label', {
      staticClass: "checkbox-inline",
      staticStyle: {
        "display": "inline-table"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedOfferings),
        expression: "selectedOfferings"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data.id,
        "checked": Array.isArray(_vm.selectedOfferings) ? _vm._i(_vm.selectedOfferings, data.id) > -1 : (_vm.selectedOfferings)
      },
      on: {
        "click": function($event) {
          return _vm.selectService('product')
        },
        "change": function($event) {
          var $$a = _vm.selectedOfferings,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedOfferings = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedOfferings = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedOfferings = $$c
          }
        }
      }
    }), _vm._v(_vm._s(data.legacy_name) + "\n                      ")])])
  })], 2)])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "margin-left": "5px"
    }
  }, [(_vm.optionDisplayArr.length > 0) ? _c('div', {
    staticClass: "displayOptionsLabel"
  }, [_vm._v("These options will be configured on the click of \"Configure Options & Save\" button")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.optionDisplayArr), function(value, index) {
    return _c('span', {
      key: index,
      staticClass: "displayOptions",
      attrs: {
        "value": index
      }
    }, [_vm._v(_vm._s(value))])
  })], 2)]), _vm._v(" "), _c('footer', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('div', {
      staticClass: "footer-buttons"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": _vm.closeConfigurePf
      }
    }, [_vm._v("\n              Close\n            ")]), _vm._v(" "), (_vm.pfThatRequiresOptionsAutoMagically.includes(_vm.functionName)) ? _c('input', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "value": "Configure Options & Save"
      },
      on: {
        "click": function($event) {
          return _vm.generateOption(_vm.functionName)
        }
      }
    }) : _c('input', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "value": "Save"
      },
      on: {
        "click": function($event) {
          return _vm.configurePfSave()
        }
      }
    })])]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.showModalSemantic) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "Modal"
    }
  }, [_c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "Modal"
    }
  }, [_c('div', {
    staticClass: "modal",
    staticStyle: {
      "height": "620px"
    },
    attrs: {
      "role": "dialog",
      "aria-labelledby": "modalTitle",
      "aria-describedby": "modalDescription"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_vm._v("\n              " + _vm._s(_vm.captionSemationPopup) + "\n            ")]
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [(_vm.isDynamicInputType()) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.stagetype !== _vm.stageTypes.scoreRanking),
        expression: "stagetype !== stageTypes.scoreRanking"
      }],
      staticClass: "form-group col-xs-6 col-sm-6 col-md-6 col-lg-6"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.semanticObj.option !== 'null_list'),
        expression: "semanticObj.option !== 'null_list'"
      }],
      staticClass: "custom-control custom-switch"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.semanticObj.isDynamicOptionsEnable),
        expression: "semanticObj.isDynamicOptionsEnable"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "id": "dynamicOptionsCheck"
      },
      domProps: {
        "checked": Array.isArray(_vm.semanticObj.isDynamicOptionsEnable) ? _vm._i(_vm.semanticObj.isDynamicOptionsEnable, null) > -1 : (_vm.semanticObj.isDynamicOptionsEnable)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.semanticObj.isDynamicOptionsEnable,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.semanticObj, "isDynamicOptionsEnable", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.semanticObj, "isDynamicOptionsEnable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.semanticObj, "isDynamicOptionsEnable", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "custom-control-label",
      attrs: {
        "for": "dynamicOptionsCheck"
      }
    }, [_vm._v("Dynamic Entity List Options")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group col-xs-6 col-sm-6 col-md-6 col-lg-6"
    }, [_c('label', {
      attrs: {
        "for": "options"
      }
    }, [_vm._v("Options")]), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("**")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.semanticObj.option),
        expression: "semanticObj.option"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "option",
        "placeholder": "Option",
        "disabled": _vm.inputType == 'Boolean',
        "autocomplete": "off"
      },
      domProps: {
        "value": (_vm.semanticObj.option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.semanticObj, "option", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
    }, [_c('label', {
      attrs: {
        "for": "next-stages"
      }
    }, [_vm._v("Next Stage")]), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("**")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.semanticObj.next),
        expression: "semanticObj.next"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "autocomplete": "off",
        "id": "next",
        "placeholder": "Next stage"
      },
      domProps: {
        "value": (_vm.semanticObj.next)
      },
      on: {
        "keyup": _vm.toLowerCaseFuncSematicNext,
        "blur": _vm.toLowerCaseFuncSematicNext,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.semanticObj, "next", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.stagetype === _vm.stageTypes.scoredResponse),
        expression: "stagetype === stageTypes.scoredResponse"
      }],
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group col-xs-6 col-sm-6 col-md-6 col-lg-6"
    }, [_c('label', {
      staticClass: "required",
      attrs: {
        "for": "options"
      }
    }, [_vm._v("Option Score")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.semanticObj.optionScore),
        expression: "semanticObj.optionScore"
      }],
      staticClass: "form-control",
      class: {
        'form-group--error': ((!_vm.$v.semanticObj.optionScore.required || !_vm.$v.semanticObj.optionScore.numberVal) && _vm.submittedSemantic)
      },
      attrs: {
        "type": "text",
        "id": "Option Score",
        "placeholder": "Option Score",
        "autocomplete": "off"
      },
      domProps: {
        "value": (_vm.semanticObj.optionScore)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.semanticObj, "optionScore", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.submittedSemantic && !_vm.$v.semanticObj.optionScore.required) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter option score.")]) : _vm._e(), _vm._v(" "), (_vm.submittedSemantic && !_vm.$v.semanticObj.optionScore.numberVal) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter decimal or integer value.")]) : _vm._e()])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.stagetype === _vm.stageTypes.scoreRanking),
        expression: "stagetype === stageTypes.scoreRanking"
      }],
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group col-xs-6 col-sm-6 col-md-6 col-lg-6"
    }, [_c('label', {
      attrs: {
        "for": "options"
      }
    }, [_vm._v("Tally Lower Limit")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.semanticObj.tallyLowerLimit),
        expression: "semanticObj.tallyLowerLimit"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": "Tally Lower Limit",
        "id": "lowerlimit",
        "autocomplete": "off"
      },
      domProps: {
        "value": (_vm.semanticObj.tallyLowerLimit)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.semanticObj, "tallyLowerLimit", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.submittedSemantic && !_vm.$v.semanticObj.tallyLowerLimit.numeric) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter a whole number.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group col-xs-6 col-sm-6 col-md-6 col-lg-6"
    }, [_c('label', {
      attrs: {
        "for": "options"
      }
    }, [_vm._v("Tally Upper Limit")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.semanticObj.tallyUpperLimit),
        expression: "semanticObj.tallyUpperLimit"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": "Tally Upper Limit",
        "id": "upperlimit",
        "autocomplete": "off"
      },
      domProps: {
        "value": (_vm.semanticObj.tallyUpperLimit)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.semanticObj, "tallyUpperLimit", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.submittedSemantic && !_vm.$v.semanticObj.tallyUpperLimit.numeric) ? _c('span', {
      staticClass: "text-red pull-left"
    }, [_vm._v("Please enter a whole number.")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.stagetype !== _vm.stageTypes.scoreRanking),
        expression: "stagetype !== stageTypes.scoreRanking"
      }],
      staticClass: "row"
    }, [_vm._m(3)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.stagetype !== _vm.stageTypes.scoreRanking),
        expression: "stagetype !== stageTypes.scoreRanking"
      }],
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group col-xs-3 col-sm-3 col-md-3"
    }, [_c('label', {
      attrs: {
        "for": "options"
      }
    }, [_vm._v("Country")]), _vm._v(" "), _c('nv-select', {
      staticClass: "form-control",
      on: {
        "change": function($event) {
          return _vm.getLanguagesInCountry()
        }
      },
      model: {
        value: (_vm.selectedCountrySemantic),
        callback: function($$v) {
          _vm.selectedCountrySemantic = $$v
        },
        expression: "selectedCountrySemantic"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Choose Country")]), _vm._v(" "), _vm._l((_vm.countryAndLanguages), function(value, key) {
      return _c('option', {
        key: key,
        domProps: {
          "value": key
        }
      }, [_vm._v(_vm._s(key))])
    })], 2)], 1), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-3 col-sm-3 col-md-3"
    }, [_c('label', {
      attrs: {
        "for": "options"
      }
    }, [_vm._v("Language")]), _vm._v(" "), _c('nv-select', {
      staticClass: "form-control",
      model: {
        value: (_vm.messageLanguageSemantic),
        callback: function($$v) {
          _vm.messageLanguageSemantic = $$v
        },
        expression: "messageLanguageSemantic"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Choose language")]), _vm._v(" "), _vm._l((_vm.languages), function(value, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": value.alias
        }
      }, [_vm._v(_vm._s(value.name))])
    })], 2)], 1), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-5 col-sm-5 col-md-5"
    }, [_c('label', {
      attrs: {
        "for": "options"
      }
    }, [_vm._v("Message")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.semanticMessage),
        expression: "semanticMessage"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "semanticMessage",
        "name": "semanticMessage",
        "placeholder": "Semantic Message"
      },
      domProps: {
        "value": (_vm.semanticMessage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.semanticMessage = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-1 col-sm-1 col-md-1"
    }, [_c('i', {
      staticClass: "fa fa-plus-circle add-property",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": _vm.addSemanticMessage
      }
    })])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.stagetype !== _vm.stageTypes.scoreRanking),
        expression: "stagetype !== stageTypes.scoreRanking"
      }],
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [(Object.keys(_vm.semanticObj.semantic).length) ? _c('table', {
      staticStyle: {
        "width": "100%",
        "margin-bottom": "20px"
      }
    }, _vm._l((_vm.semanticObj.semantic), function(countryRow, country) {
      return _c('tr', {
        key: country
      }, [_c('td', {
        staticStyle: {
          "width": "15%",
          "background-color": "#e8e8e8",
          "border-bottom": "1px solid lightgray"
        }
      }, [_c('strong', [_vm._v(_vm._s(country))])]), _vm._v(" "), _c('td', [(Object.keys(countryRow).length) ? _c('table', {
        staticStyle: {
          "width": "100%"
        }
      }, [_vm._m(4, true), _vm._v(" "), _vm._l((countryRow), function(languageRow, language) {
        return _c('tr', {
          key: language
        }, [_c('td', {
          staticStyle: {
            "width": "15%",
            "background-color": "#f3f2f2"
          }
        }, [_c('strong', [_vm._v(_vm._s(language))])]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "70%"
          }
        }, [_vm._v(_vm._s(languageRow))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.editSemanticMessage(country, language, languageRow)
            }
          }
        })]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-times-circle",
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.deleteSemanticMessage(country, language)
            }
          }
        })])])
      })], 2) : _vm._e()])])
    }), 0) : _vm._e()])]), _vm._v(" "), (_vm.semanticObj.isDynamicOptionsEnable) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.stagetype !== _vm.stageTypes.scoreRanking),
        expression: "stagetype !== stageTypes.scoreRanking"
      }],
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
    }, [_c('label', [_vm._v("Option List Source")]), _vm._v(" "), _c('nv-select', {
      staticClass: "form-control",
      attrs: {
        "id": "option"
      },
      on: {
        "change": function($event) {
          return _vm.handleOptionListSourceChange()
        }
      },
      model: {
        value: (_vm.semanticObj.optionListSource),
        callback: function($$v) {
          _vm.$set(_vm.semanticObj, "optionListSource", $$v)
        },
        expression: "semanticObj.optionListSource"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Choose Source")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "unifiedReferrals"
      }
    }, [_vm._v("Unified Referrals")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "offerings"
      }
    }, [_vm._v("Offerings")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "drillDownReferrals"
      }
    }, [_vm._v("Drill Down Referrals")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "appointmentDates"
      }
    }, [_vm._v("Appointment Dates")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
    }, [_c('label', [_vm._v("Data Destination")]), _vm._v(" "), _c('nv-select', {
      staticClass: "form-control",
      attrs: {
        "id": "option"
      },
      model: {
        value: (_vm.semanticObj.dataDestination),
        callback: function($$v) {
          _vm.$set(_vm.semanticObj, "dataDestination", $$v)
        },
        expression: "semanticObj.dataDestination"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Choose Data Destination")]), _vm._v(" "), _vm._l((_vm.availableDataDestination), function(value, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": value.value
        }
      }, [_vm._v(_vm._s(value.label))])
    })], 2)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isDynamicInputType() && !_vm.semanticObj.isDynamicOptionsEnable) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.stagetype !== _vm.stageTypes.scoreRanking),
        expression: "stagetype !== stageTypes.scoreRanking"
      }]
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.semanticObj.option !== 'null_list'),
        expression: "semanticObj.option !== 'null_list'"
      }],
      staticClass: "row"
    }, [_vm._m(5)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.semanticObj.option !== 'null_list'),
        expression: "semanticObj.option !== 'null_list'"
      }],
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "form-group col-xs-3 col-sm-3 col-md-3"
    }, [_c('label', {
      attrs: {
        "for": "options"
      }
    }, [_vm._v("Country")]), _vm._v(" "), _c('nv-select', {
      staticClass: "form-control",
      on: {
        "change": function($event) {
          return _vm.getLanguagesForStaticOption()
        }
      },
      model: {
        value: (_vm.selectedCountryStaticOption),
        callback: function($$v) {
          _vm.selectedCountryStaticOption = $$v
        },
        expression: "selectedCountryStaticOption"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Choose Country")]), _vm._v(" "), _vm._l((_vm.countryAndLanguages), function(value, key) {
      return _c('option', {
        key: key,
        domProps: {
          "value": key
        }
      }, [_vm._v(_vm._s(key))])
    })], 2)], 1), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-3 col-sm-3 col-md-3"
    }, [_c('label', {
      attrs: {
        "for": "options"
      }
    }, [_vm._v("Language")]), _vm._v(" "), _c('nv-select', {
      staticClass: "form-control",
      model: {
        value: (_vm.textLanguageStaticOption),
        callback: function($$v) {
          _vm.textLanguageStaticOption = $$v
        },
        expression: "textLanguageStaticOption"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Choose language")]), _vm._v(" "), _vm._l((_vm.languagesForStaticOption), function(value, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": value.alias
        }
      }, [_vm._v(_vm._s(value.name))])
    })], 2)], 1), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-5 col-sm-5 col-md-5"
    }, [_c('label', {
      attrs: {
        "for": "options"
      }
    }, [_vm._v("Option Display Text")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.staticOptionDisplayText),
        expression: "staticOptionDisplayText"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "staticOptionDisplayText",
        "name": "staticOptionDisplayText",
        "placeholder": "Display Option text"
      },
      domProps: {
        "value": (_vm.staticOptionDisplayText)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.staticOptionDisplayText = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-1 col-sm-1 col-md-1"
    }, [_c('i', {
      staticClass: "fa fa-plus-circle add-property",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": _vm.addStaticOptionDisplayText
      }
    })])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.stagetype !== _vm.stageTypes.scoreRanking),
        expression: "stagetype !== stageTypes.scoreRanking"
      }],
      staticClass: "row"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.semanticObj.option !== 'null_list'),
        expression: "semanticObj.option !== 'null_list'"
      }],
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [(Object.keys(_vm.semanticObj.staticOptionTextConfig).length) ? _c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, _vm._l((_vm.semanticObj.staticOptionTextConfig), function(countryRow, country) {
      return _c('tr', {
        key: country
      }, [_c('td', {
        staticStyle: {
          "width": "15%",
          "background-color": "#e8e8e8",
          "border-bottom": "1px solid lightgray"
        }
      }, [_c('strong', [_vm._v(_vm._s(country))])]), _vm._v(" "), _c('td', [(Object.keys(countryRow).length) ? _c('table', {
        staticStyle: {
          "width": "100%"
        }
      }, [_vm._m(6, true), _vm._v(" "), _vm._l((countryRow), function(languageRow, language) {
        return _c('tr', {
          key: language
        }, [_c('td', {
          staticStyle: {
            "width": "15%",
            "background-color": "#f3f2f2"
          }
        }, [_c('strong', [_vm._v(_vm._s(language))])]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "70%"
          }
        }, [_vm._v(_vm._s(languageRow))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.editStaticOptionDisplayText(country, language, languageRow)
            }
          }
        })]), _vm._v(" "), _c('td', {
          staticStyle: {
            "width": "10%"
          }
        }, [_c('i', {
          staticClass: "fa fa-times-circle",
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.deleteStaticOptionDisplayText(country, language)
            }
          }
        })])])
      })], 2) : _vm._e()])])
    }), 0) : _vm._e()])])]) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "text-red"
  }, [_vm._v("**Either next stage or Next app is mandatory.")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stagetype === _vm.stageTypes.scoreRanking),
      expression: "stagetype === stageTypes.scoreRanking"
    }],
    staticClass: "text-red"
  }, [_vm._v("*Lowest rank score lower boundary should always be blank")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stagetype === _vm.stageTypes.scoreRanking),
      expression: "stagetype === stageTypes.scoreRanking"
    }],
    staticClass: "text-red"
  }, [_vm._v("*Highest rank score upper boundary should always be blank")]), _vm._v(" "), _c('footer', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [(!_vm.semanticObj.next && !_vm.semanticObj.option) ? _c('span', {
      staticClass: "text-red pull-left",
      staticStyle: {
        "font-size": "initial",
        "margin": "10px 30px"
      }
    }, [_vm._v("Please enter options or next stage")]) : _vm._e(), _vm._v(" "), ((_vm.semanticObj.next || _vm.semanticObj.option) && _vm.inputType === 'DynamicNumber' && !_vm.semanticObj.isDynamicOptionsEnable && _vm._.isEmpty(_vm.semanticObj.staticOptionTextConfig)) ? _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.semanticObj.option !== 'null_list'),
        expression: "semanticObj.option !== 'null_list'"
      }],
      staticClass: "text-red pull-left",
      staticStyle: {
        "font-size": "initial",
        "margin": "10px 30px"
      }
    }, [_vm._v("Please enter Static Option Display Text for given option")]) : _vm._e(), _vm._v(" "), ((_vm.semanticObj.next || _vm.semanticObj.option) && _vm.semanticObj.isDynamicOptionsEnable && !_vm.semanticObj.optionListSource) ? _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.semanticObj.option !== 'null_list'),
        expression: "semanticObj.option !== 'null_list'"
      }],
      staticClass: "text-red pull-left",
      staticStyle: {
        "font-size": "initial",
        "margin": "10px 30px"
      }
    }, [_vm._v("Please select Option List Source for dynamic options")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.closeSemantic()
        }
      }
    }, [_vm._v("\n              Close\n            ")]), _vm._v(" "), _c('input', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "value": "Save"
      },
      on: {
        "click": function($event) {
          return _vm.semanticSave()
        }
      }
    })]
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.showModalNullListInfo) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal new-feature",
    staticStyle: {
      "height": "200px",
      "width": "518px"
    },
    attrs: {
      "role": "dialog",
      "aria-labelledby": "modalTitle",
      "aria-describedby": "modalDescription"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "header-style"
  }, [_c('h3', [_vm._v("Information")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "22px",
      "color": "red"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": _vm.closeNullListInfoPopUp
    }
  })])]), _vm._v(" "), _vm._m(7)])]) : _vm._e(), _vm._v(" "), (_vm.showRedemptionStageInfo) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal new-feature",
    staticStyle: {
      "height": "200px",
      "width": "518px"
    },
    attrs: {
      "role": "dialog",
      "aria-labelledby": "modalTitle",
      "aria-describedby": "modalDescription"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "header-style"
  }, [_c('h3', [_vm._v("Information")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "22px",
      "color": "red"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": _vm.closeRedemptionStageInfoPopUp
    }
  })])]), _vm._v(" "), _vm._m(8)])]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "name": "frmAddStage",
      "id": "frmAddStage",
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addOrUpdateStage.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-primary"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": "content-stage-settings"
    }
  }, [(_vm.disableStageName) ? _c('div', {
    staticClass: "message-timing"
  }, [_c('h4', {
    staticClass: "message-timing-title"
  }, [_vm._v("Message timing")]), _vm._v(" "), _c('p', {
    staticClass: "message-timing-hint"
  }, [_vm._v("Applies to every stage in this conversation that sends more than one message(Not on embedded apps, you will have to set delay there separately).")]), _vm._v(" "), _c('div', {
    staticClass: "form-inline form-group"
  }, [_c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.waitBetweenMessages),
      expression: "waitBetweenMessages"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.waitBetweenMessages) ? _vm._i(_vm.waitBetweenMessages, null) > -1 : (_vm.waitBetweenMessages)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.waitBetweenMessages,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.waitBetweenMessages = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.waitBetweenMessages = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.waitBetweenMessages = $$c
        }
      }, _vm.handleWaitBetweenMessagesToggle]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })]), _vm._v(" "), _c('label', {
    staticClass: "message-timing-toggle-label"
  }, [_vm._v("Wait between messages")])]), _vm._v(" "), (_vm.waitBetweenMessages) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "messageDelayMs"
    }
  }, [_vm._v("Delay between messages")]), _vm._v(" "), _c('div', {
    staticClass: "form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.messageDelayMs),
      expression: "messageDelayMs",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "120px",
      "text-align": "right"
    },
    attrs: {
      "type": "number",
      "id": "messageDelayMs",
      "min": _vm.messageDelayLimits.min,
      "max": _vm.messageDelayLimits.max,
      "step": "100"
    },
    domProps: {
      "value": (_vm.messageDelayMs)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.messageDelayMs = _vm._n($event.target.value)
      }, _vm.handleMessageDelayChange],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v("\n               milliseconds\n            ")]), _vm._v(" "), _c('small', {
    staticClass: "message-timing-hint"
  }, [_vm._v("Between " + _vm._s(_vm.messageDelayLimits.min) + " and " + _vm._s(_vm.messageDelayLimits.max) + " ms.")]), _vm._v(" "), (!_vm.isMessageDelayValid) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Delay must be between " + _vm._s(_vm.messageDelayLimits.min) + " and " + _vm._s(_vm.messageDelayLimits.max) + " ms.")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "flex-container"
  }, [_c('div', {
    staticClass: "form-group flex-item"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "stagename"
    }
  }, [_vm._v("Stage Type")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.stagetype.required
    },
    attrs: {
      "id": "stagetype"
    },
    model: {
      value: (_vm.stagetype),
      callback: function($$v) {
        _vm.stagetype = $$v
      },
      expression: "stagetype"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select stage type--")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.stageTypes.traditional
    }
  }, [_vm._v("Traditional")]), _vm._v(" "), (_vm.conversationType === 'scoredresponse') ? _c('option', {
    domProps: {
      "value": _vm.stageTypes.scoredResponse
    }
  }, [_vm._v("Scored Response")]) : _vm._e(), _vm._v(" "), (_vm.conversationType === 'scoredresponse') ? _c('option', {
    domProps: {
      "value": _vm.stageTypes.scoreRanking
    }
  }, [_vm._v("Score Ranking")]) : _vm._e(), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.stageTypes.embeddedConversation
    }
  }, [_vm._v("Embedded Apps")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.stageTypes.fbOptIn
    }
  }, [_vm._v("Facebook Opt In")]), _vm._v(" "), (_vm.conversationType === 'journeyReminder') ? _c('option', {
    domProps: {
      "value": _vm.stageTypes.journeyReminder
    }
  }, [_vm._v("Journey of Reminder")]) : _vm._e()]), _vm._v(" "), (_vm.submitted && !_vm.$v.stagetype.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter stage type.")]) : _vm._e()], 1), _vm._v(" "), (_vm.stagetype !== _vm.stageTypes.embeddedConversation) ? _c('div', {
    staticClass: "form-group flex-item"
  }, [_c('label', {
    attrs: {
      "for": "mediatype"
    }
  }, [_vm._v("Media Type")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.stagetype !== _vm.stageTypes.traditional,
      "id": "mediatype"
    },
    on: {
      "change": _vm.handleMediaTypeChange
    },
    model: {
      value: (_vm.mediatype),
      callback: function($$v) {
        _vm.mediatype = $$v
      },
      expression: "mediatype"
    }
  }, [_c('option', {
    attrs: {
      "value": "text"
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "image"
    }
  }, [_vm._v("Image")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "video"
    }
  }, [_vm._v("Video")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "uploadedMedia"
    }
  }, [_vm._v("Uploaded Media")])]), _vm._v(" "), (_vm.mediatype === 'uploadedMedia') ? _c('span', {
    staticClass: "text-red text-bold"
  }, [_vm._v("WARNING: Engineers Only! Kindly seek their assistance for content uploads.")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.stagetype === _vm.stageTypes.embeddedConversation) ? _c('div', {
    staticClass: "form-group flex-item embedded_conversation_container"
  }, [_c('div', {
    staticClass: "conversation_dropdown_container"
  }, [_c('label', {
    attrs: {
      "for": "conversation",
      "data-toggle": "tooltip",
      "data-html": "true",
      "title": 'Please make sure that selected embedded \napp ends with END_CONVERSATION. \nSome apps like WA MIGRATE, SCOUT, \nANC, PNC cannot be used in journey.'
    }
  }, [_vm._v("\n                    Conversation "), _c('i', {
    staticClass: "fa fa-question-circle"
  })]), _vm._v(" "), (_vm.externalConversationButton) ? _c('button', {
    attrs: {
      "type": "button",
      "title": "Edit Conversation"
    },
    on: {
      "click": _vm.editEmbeddedConversation
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "--Choose a conversation--",
      "multiple": false,
      "options": _vm.embeddedApps
    },
    on: {
      "input": _vm.setOptions
    },
    model: {
      value: (_vm.embeddedApp),
      callback: function($$v) {
        _vm.embeddedApp = $$v
      },
      expression: "embeddedApp"
    }
  }), _vm._v(" "), (_vm.conversationNotExistError) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v(" Please select valid conversation ")]) : _vm._e(), _vm._v(" "), (_vm.showValidationError && !_vm.embeddedApp) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please select a conversation to embed")]) : _vm._e(), _vm._v(" "), (_vm.embeddedApp === 'APP_UNIFIED_REFERRAL') ? _c('div', [_c('label', [_vm._v("Referral Display Option "), _c('span', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "title": 'Configure how do we want to show the referral to end user'
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle margin-10"
  })])]), _vm._v(" "), _vm._l((_vm.referralAppOptions), function(option) {
    return _c('div', {
      key: option.value
    }, [_c('label', {
      staticClass: "radio-inline view-option-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.referralType),
        expression: "referralType"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": option.value,
        "checked": _vm._q(_vm.referralType, option.value)
      },
      on: {
        "change": function($event) {
          _vm.referralType = option.value
        }
      }
    }), _vm._v(_vm._s(option.label) + "\n                    ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline public-private-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection),
      expression: "additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection) ? _vm._i(_vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection, null) > -1 : (_vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.additionalReferralConfig, "showPhysicalResouceAsPerPubliCPrivateSelection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.additionalReferralConfig, "showPhysicalResouceAsPerPubliCPrivateSelection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.additionalReferralConfig, "showPhysicalResouceAsPerPubliCPrivateSelection", $$c)
        }
      }
    }
  }), _vm._v("Show Physical Resources as per Public/Private Selection\n                    ")])], 2) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, [_c('div', {
    staticClass: "form-group flex-item"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "stagename"
    }
  }, [_vm._v("Stage Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stagename),
      expression: "stagename"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.stagename.required
    },
    attrs: {
      "type": "text",
      "disabled": _vm.disableStageName,
      "id": "stagename",
      "placeholder": "Name of the stage"
    },
    domProps: {
      "value": (_vm.stagename)
    },
    on: {
      "keyup": _vm.toLowerCaseFunc,
      "blur": _vm.toLowerCaseFunc,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stagename = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.stagename.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter stage name.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && !_vm.$v.stagename.stageNameRegex) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v(" The name can only contain alphanumeric, underscore and hyphen characters.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stagetype !== _vm.stageTypes.scoreRanking && _vm.mediatype != 'uploadedMedia'),
      expression: "stagetype !== stageTypes.scoreRanking && mediatype != 'uploadedMedia'"
    }],
    staticClass: "form-group flex-item"
  }, [_c('label', {
    attrs: {
      "for": "input-type"
    }
  }, [_vm._v("Input Type")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.mediatype !== 'text' || [_vm.stageTypes.embeddedConversation, _vm.stageTypes.fbOptIn, _vm.stageTypes.journeyReminder].includes(_vm.stagetype),
      "id": "input-type"
    },
    on: {
      "change": function($event) {
        return _vm.setOptions(true)
      }
    },
    model: {
      value: (_vm.inputType),
      callback: function($$v) {
        _vm.inputType = $$v
      },
      expression: "inputType"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--No input--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Number"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Boolean"
    }
  }, [_vm._v("Boolean")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Text"
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DynamicNumber"
    }
  }, [_vm._v("Dynamic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "whatsapp_flows"
    }
  }, [_vm._v("WhatsApp Flows")]), _vm._v(" "), (_vm.convoCurrent.topic_id) ? _c('option', {
    attrs: {
      "value": "nlpDecision"
    }
  }, [_vm._v("NLP Decision")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mediatype === 'uploadedMedia'),
      expression: "mediatype === 'uploadedMedia'"
    }],
    staticClass: "form-group flex-item"
  }, [_c('label', {
    attrs: {
      "for": "input-type"
    }
  }, [_vm._v("Select Media")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "--Choose a media--",
      "multiple": false,
      "options": _vm.mediaList
    },
    model: {
      value: (_vm.uploadedMedia),
      callback: function($$v) {
        _vm.uploadedMedia = $$v
      },
      expression: "uploadedMedia"
    }
  }), _vm._v(" "), (_vm.selectedMedia) ? _c('div', {
    staticClass: "stage-media-preview"
  }, [_c('media-preview', {
    attrs: {
      "format": _vm.selectedMedia.media_format || _vm.selectedMedia.media_type || 'image',
      "media-id": _vm.selectedMedia.id,
      "media-name": _vm.selectedMedia.media_name,
      "missing-text": ": no stored file"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputType === 'whatsapp_flows'),
      expression: "inputType === 'whatsapp_flows'"
    }],
    staticClass: "flex-container"
  }, [_c('div', {
    staticClass: "form-group flex-item"
  }, [_c('label', {
    attrs: {
      "for": "whatsapp-flow-id"
    }
  }, [_vm._v("WhatsApp Flow")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "id": "whatsapp-flow-id"
    },
    model: {
      value: (_vm.whatsappFlowId),
      callback: function($$v) {
        _vm.whatsappFlowId = $$v
      },
      expression: "whatsappFlowId"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select a Flow--")]), _vm._v(" "), _vm._l((_vm.whatsappFlows), function(flow) {
    return _c('option', {
      key: flow.id,
      domProps: {
        "value": flow.id
      }
    }, [_vm._v(_vm._s(flow.name))])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputType === 'DynamicNumber'),
      expression: "inputType === 'DynamicNumber'"
    }],
    staticClass: "form-group flex-item"
  }, [_c('label', {
    staticClass: "checkbox-inline referral-check-box",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isRedemptionStage),
      expression: "isRedemptionStage"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isRedemptionStage) ? _vm._i(_vm.isRedemptionStage, null) > -1 : (_vm.isRedemptionStage)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isRedemptionStage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isRedemptionStage = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isRedemptionStage = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isRedemptionStage = $$c
        }
      }, _vm.changeRedemptionStage]
    }
  }), _vm._v("Is redemption stage\n                  "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputType === 'DynamicNumber'),
      expression: "inputType === 'DynamicNumber'"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "margin-left": "5px",
      "font-size": "15px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.showRedemptionStageInfoPopUp
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stagetype === _vm.stageTypes.fbOptIn),
      expression: "stagetype === stageTypes.fbOptIn"
    }],
    staticClass: "flex-container"
  }, [_c('div', {
    staticClass: "form-group flex-item"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "stagename"
    }
  }, [_vm._v("Topic")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "--Choose a topic--",
      "multiple": false,
      "options": _vm.topicList
    },
    model: {
      value: (_vm.topic),
      callback: function($$v) {
        _vm.topic = $$v
      },
      expression: "topic"
    }
  }), _vm._v(" "), (_vm.showValidationError && !_vm.topic) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please select a topic")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group flex-item"
  }, [_c('label', {
    attrs: {
      "for": "input-type"
    }
  }, [_vm._v("Frequency")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "id": "frequency-type"
    },
    on: {
      "change": _vm.setOptions
    },
    model: {
      value: (_vm.frequency),
      callback: function($$v) {
        _vm.frequency = $$v
      },
      expression: "frequency"
    }
  }, [_c('option', {
    attrs: {
      "value": "DAILY"
    }
  }, [_vm._v("Daily")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WEEKLY"
    }
  }, [_vm._v("Weekly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MONTHLY"
    }
  }, [_vm._v("Monthly")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding": "6px 12px"
    }
  }, [_c('label', {
    attrs: {
      "for": "option_nextstage"
    }
  }, [_vm._v("Option / Next Stage / Semantic Text ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle add-property",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.openSemantic()
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputType === 'DynamicNumber'),
      expression: "inputType === 'DynamicNumber'"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "margin-left": "55px",
      "font-size": "22px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.showNullListInfoPopUp
    }
  }), _vm._v(" "), (_vm.showValidationError) ? _c('div', {
    ref: "errorDiv",
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "100px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Option")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Next Stage")]), _vm._v(" "), (_vm.stagetype === _vm.stageTypes.scoredResponse) ? _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Option Score")]) : _vm._e(), _vm._v(" "), (_vm.stagetype === _vm.stageTypes.scoreRanking) ? _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Tally Lower Limit")]) : _vm._e(), _vm._v(" "), (_vm.stagetype === _vm.stageTypes.scoreRanking) ? _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Tally Upper Limit")]) : _vm._e()])]), _vm._v(" "), (_vm.semanticData && Object.keys(_vm.semanticData).length) ? _c('draggable', {
    attrs: {
      "tag": "tbody",
      "disabled": !_vm.draggable
    },
    on: {
      "end": _vm.listMoved
    },
    model: {
      value: (_vm.semanticData),
      callback: function($$v) {
        _vm.semanticData = $$v
      },
      expression: "semanticData"
    }
  }, _vm._l((_vm.semanticData), function(item, index) {
    return _c('tr', {
      key: item.option
    }, [_c('td', {
      staticClass: "edit-delete-btn-container"
    }, [_c('i', {
      staticClass: "fa fa-align-justify handle"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.openSemantic(item, index)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.deleteSemantic(item, index)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "text-center wrap-text-block"
    }, [_vm._v(_vm._s(item.option))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "text-center wrap-text-block"
    }, [_vm._v(_vm._s(item.next))])]), _vm._v(" "), (_vm.stagetype === _vm.stageTypes.scoredResponse) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(" " + _vm._s(item.optionScore) + " ")]) : _vm._e(), _vm._v(" "), (_vm.stagetype === _vm.stageTypes.scoreRanking) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(" " + _vm._s(item.tallyLowerLimit) + " ")]) : _vm._e(), _vm._v(" "), (_vm.stagetype === _vm.stageTypes.scoreRanking) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(" " + _vm._s(item.tallyUpperLimit) + " ")]) : _vm._e()])
  }), 0) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stagetype !== _vm.stageTypes.traditional),
      expression: "stagetype !== stageTypes.traditional"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group flex-container"
  }, [_c('div', {
    staticClass: "form-group flex-item col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('label', {
    attrs: {
      "for": "tags"
    }
  }, [_vm._v("Analysis Tags")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "Add Tag",
      "multiple": true,
      "options": _vm.tagTypes
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stagetype === _vm.stageTypes.traditional),
      expression: "stagetype === stageTypes.traditional"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 flex-container"
  }, [_c('div', {
    staticClass: "form-group flex-item"
  }, [_c('div', [_c('div', {
    staticClass: "form-inline form-group"
  }, [_c('label', [_vm._v("Scheduled Conversation (Optional)")]), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toggleSwitchDelay),
      expression: "toggleSwitchDelay"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.toggleSwitchDelay) ? _vm._i(_vm.toggleSwitchDelay, null) > -1 : (_vm.toggleSwitchDelay)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.toggleSwitchDelay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.toggleSwitchDelay = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.toggleSwitchDelay = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.toggleSwitchDelay = $$c
        }
      }, _vm.handleDelayToggle]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDelayTactics),
      expression: "showDelayTactics"
    }],
    ref: "errorKeywordConversation"
  }, [_c('div', {
    staticClass: "form-inline form-group",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', [_vm._v("Message Template Name ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('nv-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "input-type"
    },
    on: {
      "change": function($event) {
        return _vm.onTemplateChangeCalculateButtonLength()
      }
    },
    model: {
      value: (_vm.msgTemplateName),
      callback: function($$v) {
        _vm.msgTemplateName = $$v
      },
      expression: "msgTemplateName"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Template--")]), _vm._v(" "), _vm._l((_vm.nudgesList), function(each, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": each.msg_template_name
      }
    }, [_vm._v(_vm._s(each.msg_template_name))])
  })], 2), _vm._v(" "), (_vm.msgTemplateName) ? _c('div', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onNudgePreviewClick(_vm.msgTemplateName, {
          dynamic_value_configuration: _vm.dynamic_value_configuration,
          msg_template_name: _vm.msgTemplateName
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.isDynamicTemplate('', _vm.msgTemplateName) ? 'Configure' : 'Preview'))]), (_vm.turnCountry) ? _c('small', {
    staticClass: "turn-country-hint"
  }, [_vm._v("from " + _vm._s(_vm.turnCountry))]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.isInvalidMessageTemplate && !_vm.msgTemplateName && _vm.scheduledAppKeyword !== -1) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please select message template")]) : _vm._e(), _vm._v(" "), (_vm.isInvalidMessageTemplate && _vm.msgTemplateName && !_vm.checkIfNudgeConfigurationValid({
    dynamic_value_configuration: _vm.dynamic_value_configuration,
    msg_template_name: _vm.msgTemplateName
  })) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please configure dynamic nudge.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "nudge-container"
  }, [_c('div', {
    staticClass: "form-inline form-group",
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('label', [_vm._v("Context ")]), _vm._v("  \n                              "), _c('treeselect', {
    attrs: {
      "placeholder": "--Select Context--",
      "multiple": false,
      "options": _vm.contextOptions
    },
    on: {
      "input": _vm.setContextOption
    },
    model: {
      value: (_vm.followupNudges.context),
      callback: function($$v) {
        _vm.$set(_vm.followupNudges, "context", $$v)
      },
      expression: "followupNudges.context"
    }
  })], 1), _vm._v(" "), (_vm.followupNudges.context) ? _c('div', {
    staticClass: "margin-bottom-20",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-rounded btn-nudge",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addNudge
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" Add Nudge\n                              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.followupNudges.delays), function(nudgeDelay, index) {
    return _c('div', {
      key: index,
      ref: "nudgeDiv",
      refInFor: true
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('label', [_vm._v("Delay Nudge " + _vm._s(index + 1) + ":")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2 btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteConversation(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "flex-container option-border",
      staticStyle: {
        "padding": "0px",
        "margin-bottom": "10px",
        "padding-top": "10px"
      }
    }, [_c('div', {
      staticClass: "form-group flex-small-item"
    }, [_c('label', {
      attrs: {
        "for": "Conversation"
      }
    }, [_vm._v("Delay until next nudge")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nudgeDelay.quantity),
        expression: "nudgeDelay.quantity"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "60px",
        "text-align": "right"
      },
      attrs: {
        "type": "text",
        "placeholder": "Delay"
      },
      domProps: {
        "value": (nudgeDelay.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(nudgeDelay, "quantity", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('nv-select', {
      staticClass: "form-control",
      staticStyle: {
        "margin-left": "10px",
        "width": "100%"
      },
      attrs: {
        "id": "input-type"
      },
      model: {
        value: (nudgeDelay.units),
        callback: function($$v) {
          _vm.$set(nudgeDelay, "units", $$v)
        },
        expression: "nudgeDelay.units"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("--Select Unit--")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "hrs"
      }
    }, [_vm._v("hrs")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "days"
      }
    }, [_vm._v("days")])])], 1), _vm._v(" "), (_vm.showValidationError && (nudgeDelay.msg_template_name || _vm.scheduledAppKeyword === -1) && !(nudgeDelay.quantity && nudgeDelay.units)) ? _c('span', {
      staticClass: "text-red"
    }, [_vm._v("Please select delay and Unit.")]) : _vm._e(), _vm._v(" "), (_vm.showValidationError && ((nudgeDelay.units === 'hrs' && nudgeDelay.quantity < 24) || (nudgeDelay.units === 'days' && nudgeDelay.quantity < 1))) ? _c('span', {
      staticClass: "text-red"
    }, [_vm._v("Delay should be minimum 24 hours or 1 day.")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flex-small-item flex-message-template"
    }, [_c('div', [_c('label', {
      staticStyle: {
        "white-space": "pre"
      }
    }, [_vm._v("Message Template Name : ")]), _vm._v(" "), _c('nv-select', {
      staticClass: "form-control",
      attrs: {
        "id": "input-type"
      },
      on: {
        "change": function($event) {
          return _vm.onTemplateChangeCalculateButtonLength(nudgeDelay)
        }
      },
      model: {
        value: (nudgeDelay.msg_template_name),
        callback: function($$v) {
          _vm.$set(nudgeDelay, "msg_template_name", $$v)
        },
        expression: "nudgeDelay.msg_template_name"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("--Select Template--")]), _vm._v(" "), _vm._l((_vm.nudgesList), function(each, key) {
      return _c('option', {
        key: key,
        domProps: {
          "value": each.msg_template_name
        }
      }, [_vm._v(_vm._s(each.msg_template_name))])
    })], 2), _vm._v(" "), _c('div', [(_vm.showValidationError && (nudgeDelay.quantity || nudgeDelay.units) && !nudgeDelay.msg_template_name && _vm.scheduledAppKeyword !== -1) ? _c('span', {
      staticClass: "text-red pull-right"
    }, [_vm._v("Please select message template")]) : _vm._e(), _vm._v(" "), (nudgeDelay.msg_template_name && _vm.showValidationError && !_vm.checkIfNudgeConfigurationValid(nudgeDelay)) ? _c('span', {
      staticClass: "text-red pull-right"
    }, [_vm._v("Please configure dynamic nudge.")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "min-height": "15px"
      }
    }, [(nudgeDelay.msg_template_name) ? _c('div', [_c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.onNudgePreviewClick(nudgeDelay.msg_template_name, nudgeDelay, true)
        }
      }
    }, [_vm._v(_vm._s(_vm.isDynamicTemplate('', nudgeDelay.msg_template_name) ? 'Configure' : 'Preview'))]), (_vm.turnCountry) ? _c('small', {
      staticClass: "turn-country-hint"
    }, [_vm._v("from " + _vm._s(_vm.turnCountry))]) : _vm._e()]) : _vm._e()])], 1)])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-inline form-group",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', [_vm._v("Delay : ")]), _vm._v("  \n                              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delay.quantity),
      expression: "delay.quantity"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "60px",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "placeholder": "Delay"
    },
    domProps: {
      "value": (_vm.delay.quantity)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateDelay($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.delay, "quantity", $event.target.value)
      }
    }
  }), _vm._v("\n                               \n                              "), _c('nv-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "id": "input-type"
    },
    on: {
      "change": function($event) {
        return _vm.validateDelay()
      }
    },
    model: {
      value: (_vm.delay.units),
      callback: function($$v) {
        _vm.$set(_vm.delay, "units", $$v)
      },
      expression: "delay.units"
    }
  }, [_c('option', {
    attrs: {
      "value": "mins"
    }
  }, [_vm._v("mins")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hrs"
    }
  }, [_vm._v("hrs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "days"
    }
  }, [_vm._v("days")])]), _vm._v("\n                               \n                              "), _c('i', {
    staticClass: "fa fa-times-circle fa-lg",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.resetDelay()
      }
    }
  }), _vm._v("\n                                 \n                              "), (_vm.isInvalidDelay) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Delay is minimum 60 minutes.")]) : _vm._e()], 1), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "form-inline form-group",
    staticStyle: {
      "margin-top": "10px",
      "min-width": "290px"
    }
  }, [_c('label', [_vm._v("Send Time (24-hour) : ")]), _vm._v("  \n                              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendTime.hours),
      expression: "sendTime.hours"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "min": "0",
      "max": "23",
      "placeholder": "HH"
    },
    domProps: {
      "value": (_vm.sendTime.hours)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateSendTime($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendTime, "hours", $event.target.value)
      }
    }
  }), _vm._v("\n                                :  \n                              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendTime.minutes),
      expression: "sendTime.minutes"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "min": "0",
      "max": "59",
      "placeholder": "MM"
    },
    domProps: {
      "value": (_vm.sendTime.minutes)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateSendTime($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendTime, "minutes", $event.target.value)
      }
    }
  }), _vm._v("\n                               \n                              "), _c('i', {
    staticClass: "fa fa-times-circle fa-lg",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.resetSendTime()
      }
    }
  }), _vm._v("\n                                 \n                              "), (_vm.isInvalidSendTime) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please enter valid time")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.entries), function(entry, index) {
    return _c('div', {
      key: index
    }, [_c('label', [_vm._v("Button Option " + _vm._s(index + 1) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "option-border"
    }, [_c('div', {
      staticClass: "form-inline form-group",
      staticStyle: {
        "margin-bottom": "0px"
      }
    }, [_c('label', [_vm._v("Keyword")]), _vm._v("  \n                                "), _c('treeselect', {
      attrs: {
        "disabled": !!entry.scheduledKeywordlessConversation,
        "placeholder": "--Select keyword--",
        "multiple": false,
        "options": _vm.allKeywords
      },
      on: {
        "input": function($event) {
          return _vm.validateScheduledAppKeywordNew(index, $event)
        }
      },
      model: {
        value: (entry.scheduledAppKeyword),
        callback: function($$v) {
          _vm.$set(entry, "scheduledAppKeyword", $$v)
        },
        expression: "entry.scheduledAppKeyword"
      }
    }), _vm._v(" "), (entry.isInvalidKeywordConversation) ? _c('div', [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("Please select keyword or keywordless conversation")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "form-inline form-group",
      staticStyle: {
        "margin-top": "10px",
        "margin-bottom": "10px"
      }
    }, [_c('label', [_vm._v("Conversation : ")]), _vm._v("  \n                                "), (entry.scheduledAppConversation) ? _c('label', [_vm._v(_vm._s(entry.scheduledAppConversation))]) : _vm._e(), _vm._v(" "), (!entry.scheduledAppConversation || entry.scheduledKeywordlessConversation) ? _c('label', [_vm._v(" - ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      class: {
        'disabledDiv': !entry.scheduledAppKeyword && !entry.scheduledKeywordlessConversation
      },
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v(" ------ Or ------ ")])]), _vm._v(" "), _c('div', {
      staticClass: "form-inline form-group",
      staticStyle: {
        "margin-top": "10px",
        "margin-bottom": "0px"
      }
    }, [_c('label', [_vm._v("Keywordless Conversation ")]), _vm._v("  \n                                "), _c('treeselect', {
      attrs: {
        "disabled": !!entry.scheduledAppKeyword,
        "placeholder": "--Select keywordless conversation--",
        "multiple": false,
        "options": _vm.keywordlessConvoNew
      },
      on: {
        "input": function($event) {
          return _vm.validateScheduledKeywordlessConversationNew(index, $event)
        }
      },
      model: {
        value: (entry.scheduledKeywordlessConversation),
        callback: function($$v) {
          _vm.$set(entry, "scheduledKeywordlessConversation", $$v)
        },
        expression: "entry.scheduledKeywordlessConversation"
      }
    }), _vm._v(" "), (entry.isInvalidKeywordConversation) ? _c('div', [_c('span', {
      staticClass: "text-red"
    }, [_vm._v("Please select keywordless conversation or keyword")])]) : _vm._e()], 1)])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isScreening),
      expression: "!isScreening"
    }]
  }, [_c('label', [_vm._v("Recommendation")]), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toggleSwitchRecommendation),
      expression: "toggleSwitchRecommendation"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.toggleSwitchRecommendation) ? _vm._i(_vm.toggleSwitchRecommendation, null) > -1 : (_vm.toggleSwitchRecommendation)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.toggleSwitchRecommendation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.toggleSwitchRecommendation = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.toggleSwitchRecommendation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.toggleSwitchRecommendation = $$c
        }
      }, _vm.handleRecommendationToggle]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleSwitchRecommendation),
      expression: "toggleSwitchRecommendation"
    }]
  }, [_c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.recommendation),
      callback: function($$v) {
        _vm.recommendation = $$v
      },
      expression: "recommendation"
    }
  }, _vm._l((_vm.allMethods), function(value, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value.name + '[' + value.altName + ']'))])
  }), 0)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('label', {
    attrs: {
      "for": "tags"
    }
  }, [_vm._v("Analysis Tags")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "Add Tag",
      "multiple": true,
      "options": _vm.tagTypes
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group flex-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-lg-12"
  }, [_c('div', {
    staticClass: "reload-conversation"
  }, [_c('label', [_vm._v("Next App (if any) "), _c('span', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "title": 'Subsequent app is available for Unified \nReferral and Location for Referral only'
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle margin-10"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "refresh-conversation"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "fa fa-refresh rotate",
    attrs: {
      "title": "Click to refresh the contents of the list"
    },
    on: {
      "click": function($event) {
        return _vm.refreshApps()
      }
    }
  })])])]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "--Select App--",
      "multiple": false,
      "options": _vm.allApps
    },
    on: {
      "input": _vm.setOptions
    },
    model: {
      value: (_vm.nextApp),
      callback: function($$v) {
        _vm.nextApp = $$v
      },
      expression: "nextApp"
    }
  }), _vm._v(" "), (_vm.nextApp === 'APP_UNIFIED_REFERRAL') ? _c('div', [_c('label', [_vm._v("Referral Display Option "), _c('span', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "title": 'Configure how do we want to show the referral to end user'
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle margin-10"
  })])]), _vm._v(" "), _vm._l((_vm.referralAppOptions), function(option) {
    return _c('div', {
      key: option.value
    }, [_c('label', {
      staticClass: "radio-inline view-option-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.referralType),
        expression: "referralType"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": option.value,
        "checked": _vm._q(_vm.referralType, option.value)
      },
      on: {
        "change": function($event) {
          _vm.referralType = option.value
        }
      }
    }), _vm._v(_vm._s(option.label) + "\n                          ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline public-private-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection),
      expression: "additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection) ? _vm._i(_vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection, null) > -1 : (_vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.additionalReferralConfig, "showPhysicalResouceAsPerPubliCPrivateSelection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.additionalReferralConfig, "showPhysicalResouceAsPerPubliCPrivateSelection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.additionalReferralConfig, "showPhysicalResouceAsPerPubliCPrivateSelection", $$c)
        }
      }
    }
  }), _vm._v("Show Physical Resources as per Public/Private Selection\n                        ")])], 2) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-lg-12"
  }, [_c('label', [_vm._v("Subsequent App (The App/Conversation that comes after Next App)")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "--Select Subsequent App--",
      "multiple": false,
      "options": _vm.filteredApps,
      "disabled": _vm.isDisabledSubsequentApp
    },
    on: {
      "input": _vm.setOptions
    },
    model: {
      value: (_vm.subsequentApp),
      callback: function($$v) {
        _vm.subsequentApp = $$v
      },
      expression: "subsequentApp"
    }
  }), _vm._v(" "), (_vm.subsequentApp === 'APP_UNIFIED_REFERRAL') ? _c('div', [_vm._l((_vm.referralAppOptions), function(option) {
    return _c('div', {
      key: option.value
    }, [_c('label', {
      staticClass: "radio-inline view-option-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.referralType),
        expression: "referralType"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": option.value,
        "checked": _vm._q(_vm.referralType, option.value)
      },
      on: {
        "change": function($event) {
          _vm.referralType = option.value
        }
      }
    }), _vm._v(_vm._s(option.label) + "\n                              ")])])
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline public-private-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection),
      expression: "additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection) ? _vm._i(_vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection, null) > -1 : (_vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.additionalReferralConfig.showPhysicalResouceAsPerPubliCPrivateSelection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.additionalReferralConfig, "showPhysicalResouceAsPerPubliCPrivateSelection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.additionalReferralConfig, "showPhysicalResouceAsPerPubliCPrivateSelection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.additionalReferralConfig, "showPhysicalResouceAsPerPubliCPrivateSelection", $$c)
        }
      }
    }
  }), _vm._v("Show Physical Resources as per Public/Private Selection\n                            ")])], 2) : _vm._e()], 1)]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.failed),
      expression: "failed"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Next stage if there's an input failure"
    },
    domProps: {
      "value": (_vm.failed)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.failed = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stagetype === _vm.stageTypes.traditional),
      expression: "stagetype === stageTypes.traditional"
    }],
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 alignfd"
  }, [_c('button', {
    staticClass: "btn btn-configurepf",
    on: {
      "click": _vm.configurePf
    }
  }, [_vm._v(" " + _vm._s((this.stageDetails && this.stageDetails.processingFunctionConfig && this.stageDetails.processingFunctionConfig.functionName) ? 'Edit PF' : 'Configure PF') + " ")]), _vm._v(" "), (_vm.functionAlias) ? _c('button', {
    staticClass: "btn btn-deletepf",
    on: {
      "click": _vm.deletePf
    }
  }, [_vm._v(" Delete PF ")]) : _vm._e(), _vm._v(" "), (_vm.functionAlias) ? _c('div', {
    staticClass: "displaypf"
  }, [_c('b', [_vm._v(_vm._s(_vm.functionAlias))])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stagetype === _vm.stageTypes.journeyReminder),
      expression: "stagetype === stageTypes.journeyReminder"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group flex-container"
  }, [_c('div', {
    ref: "errorKeywordConversation",
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "form-inline form-group"
  }, [_c('label', [_vm._v("Delay : ")]), _vm._v("  \n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delay.quantity),
      expression: "delay.quantity"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "60px",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "placeholder": "Delay"
    },
    domProps: {
      "value": (_vm.delay.quantity)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateDelay($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.delay, "quantity", $event.target.value)
      }
    }
  }), _vm._v("\n                       \n                      "), _c('nv-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "id": "input-type"
    },
    on: {
      "change": function($event) {
        return _vm.validateDelay()
      }
    },
    model: {
      value: (_vm.delay.units),
      callback: function($$v) {
        _vm.$set(_vm.delay, "units", $$v)
      },
      expression: "delay.units"
    }
  }, [_c('option', {
    attrs: {
      "value": "hours"
    }
  }, [_vm._v("hours")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "days"
    }
  }, [_vm._v("days")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weeks"
    }
  }, [_vm._v("weeks")])]), _vm._v("\n                       \n                      "), _c('i', {
    staticClass: "fa fa-times-circle fa-lg",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.resetDelay()
      }
    }
  }), _vm._v("\n                         \n                      "), (_vm.isInvalidDelay) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Delay should be minimum 1 hour.")]) : _vm._e()], 1), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "form-inline form-group",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', [_vm._v("Send Time (24 hours) (Optional)")]), _vm._v("  \n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendTime.hours),
      expression: "sendTime.hours"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "min": "0",
      "max": "23",
      "placeholder": "HH"
    },
    domProps: {
      "value": (_vm.sendTime.hours)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateSendTime($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendTime, "hours", $event.target.value)
      }
    }
  }), _vm._v("\n                        :  \n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendTime.minutes),
      expression: "sendTime.minutes"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "text-align": "right"
    },
    attrs: {
      "type": "text",
      "min": "0",
      "max": "59",
      "placeholder": "MM"
    },
    domProps: {
      "value": (_vm.sendTime.minutes)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateSendTime($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendTime, "minutes", $event.target.value)
      }
    }
  }), _vm._v("\n                       \n                      "), _c('i', {
    staticClass: "fa fa-times-circle fa-lg",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.resetSendTime()
      }
    }
  }), _vm._v("\n                         \n                      "), (_vm.isInvalidSendTime) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("Please enter valid time")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-inline form-group",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', [_vm._v("Message Template Name : ")]), _vm._v("  \n                      "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('nv-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "input-type"
    },
    on: {
      "change": function($event) {
        return _vm.onTemplateChange()
      }
    },
    model: {
      value: (_vm.msgTemplateName),
      callback: function($$v) {
        _vm.msgTemplateName = $$v
      },
      expression: "msgTemplateName"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Template--")]), _vm._v(" "), _vm._l((_vm.nudgesList), function(each, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": each.msg_template_name
      }
    }, [_vm._v(_vm._s(each.msg_template_name))])
  })], 2), _vm._v(" "), (_vm.msgTemplateName) ? _c('div', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onNudgePreviewClick(_vm.msgTemplateName, {
          dynamic_value_configuration: _vm.dynamic_value_configuration,
          msg_template_name: _vm.msgTemplateName
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.isDynamicTemplate('', _vm.msgTemplateName) ? 'Configure' : 'Preview'))]), (_vm.turnCountry) ? _c('small', {
    staticClass: "turn-country-hint"
  }, [_vm._v("from " + _vm._s(_vm.turnCountry))]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.isInvalidMessageTemplate && !_vm.msgTemplateName) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please select message template")]) : _vm._e(), _vm._v(" "), (_vm.msgTemplateName && !_vm.checkIfNudgeConfigurationValid({
    dynamic_value_configuration: _vm.dynamic_value_configuration,
    msg_template_name: _vm.msgTemplateName
  })) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please configure dynamic nudge.")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  })])])])])]), _vm._v(" "), (_vm.showMessageSetValidationError) ? _c('div', {
    ref: "messageSetTop",
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.messageSetErrorMessage))]) : _vm._e(), _vm._v(" "), (_vm.stagetype !== _vm.stageTypes.embeddedConversation && _vm.stagetype !== _vm.stageTypes.journeyReminder) ? _c('message-set', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mediatype !== 'uploadedMedia'),
      expression: "mediatype !== 'uploadedMedia'"
    }],
    ref: "messageSet",
    attrs: {
      "allMessages": _vm.allMessages,
      "stageName": _vm.stagename,
      "mediaType": _vm.mediatype,
      "countryAndLanguages": _vm.countryAndLanguages
    }
  }) : _vm._e(), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isScreening),
      expression: "isScreening"
    }]
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Methods Addition/Removal")]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addOrRemoveMethod.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('label', [_vm._v("Option")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    model: {
      value: (_vm.methodOption),
      callback: function($$v) {
        _vm.methodOption = $$v
      },
      expression: "methodOption"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Option--")]), _vm._v(" "), _vm._l((_vm.allOptions), function(each, index) {
    return _c('option', {
      key: index
    }, [_vm._v(_vm._s(each))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('label', [_vm._v("Action")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.frmAddRemoveMethodSubmitted && _vm.methodTypeModificationRequired
    },
    model: {
      value: (_vm.methodTypeModification),
      callback: function($$v) {
        _vm.methodTypeModification = $$v
      },
      expression: "methodTypeModification"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Action--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "add"
    }
  }, [_vm._v("Add Methods")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "remove"
    }
  }, [_vm._v("Remove Methods")])]), _vm._v(" "), (_vm.frmAddRemoveMethodSubmitted && _vm.methodTypeModificationRequired) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please select method action.")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-10 col-xs-10"
  }, [_c('label', [_vm._v("Methods")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.choosenMethods),
      callback: function($$v) {
        _vm.choosenMethods = $$v
      },
      expression: "choosenMethods"
    }
  }, _vm._l((_vm.allRecommendationMethods), function(value, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value.name + ' [' + value.altName + ']'))])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-2"
  }, [_c('label', [_vm._v("   ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle add-property",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.addOrRemoveMethod
    }
  })])])])])])])]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMethodsTable),
      expression: "showMethodsTable"
    }],
    staticClass: "methods-container"
  }, [_vm._m(13), _vm._v(" "), _vm._l((_vm.methods), function(value, eachOption) {
    return _c('div', {
      key: eachOption,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 col-lg-12 col-sm-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3 col-lg-3 col-sm-3 col-xs-3"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6 col-lg-6 col-sm-6 col-xs-6"
    }, [_vm._v(_vm._s(eachOption))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 col-lg-6 col-sm-6 col-xs-6"
    }, [_vm._v(_vm._s(value.type))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-9 col-lg-9 col-sm-9 col-xs-9"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-11 col-lg-11 col-sm-11 col-xs-11"
    }, [_vm._v(_vm._s(value.methods))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
    }, [_c('i', {
      staticClass: "fa fa-times-circle add-property",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.deleteMethodOption(eachOption, _vm.methods)
        }
      }
    })])])])])])])
  })], 2), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  })]), _vm._v(" "), (_vm.showNudgePreview) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "max-width": "800px",
      "height": "max-content"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "20px",
      "max-height": "400px",
      "overflow-y": "auto"
    }
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "margin-bottom-10px"
    }, [(_vm.showCountryPicker) ? [_c('span', {
      staticClass: "nudge-language"
    }, [_vm._v("Country :")]), _vm._v(" "), _c('nv-select', {
      staticClass: "form-control",
      staticStyle: {
        "display": "inline-block",
        "min-width": "180px",
        "vertical-align": "middle"
      },
      on: {
        "change": function($event) {
          return _vm.onTurnCountryChange()
        }
      },
      model: {
        value: (_vm.turnCountry),
        callback: function($$v) {
          _vm.turnCountry = $$v
        },
        expression: "turnCountry"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("-- Select Country --")]), _vm._v(" "), _vm._l((_vm.turnCountryList), function(country) {
      return _c('option', {
        key: country,
        domProps: {
          "value": country
        }
      }, [_vm._v(_vm._s(country))])
    })], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "8px"
      }
    }, [_vm._v("Templates differ per country's Turn namespace. Select a country to load them.")])] : [_c('span', [_vm._v("Templates from "), _c('b', [_vm._v(_vm._s(_vm.turnCountry))])]), _vm._v(" "), (_vm.turnCountryList.length > 1) ? _c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.showCountryPicker = true
        }
      }
    }, [_vm._v("Change Country")]) : _vm._e()]], 2), _vm._v(" "), (_vm.turnCountry) ? _c('div', [_c('div', {
      staticClass: "nudge-origin-title"
    }, [_vm._v("WhatsApp Nudge(s):")]), _vm._v(" "), _vm._l((_vm.nudgePreviewData), function(data, index) {
      return _c('div', {
        key: 'nudge' + index,
        staticClass: "margin-bottom-10px"
      }, [_c('span', {
        staticClass: "nudge-language"
      }, [_vm._v(_vm._s(data.language) + " :")]), _vm._v(" "), (data.turn_template_data && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(data.turn_template_data.HEADER_FORMAT)) ? _c('div', {
        staticStyle: {
          "max-width": "260px"
        }
      }, [_c('media-preview', {
        attrs: {
          "format": data.turn_template_data.HEADER_FORMAT,
          "media-id": data.media_id,
          "media-name": data.media_name || '',
          "file-name": data.media_file_name || '',
          "language-id": data.language_id
        }
      })], 1) : _vm._e(), _vm._v(" "), (data.turn_template_data && data.turn_template_data.HEADER) ? _c('div', {
        staticClass: "nudge-whatsapp-header"
      }, [_vm._l((data.headerObj.text), function(part, index) {
        return _c('span', {
          key: 'header' + index
        }, [_vm._v("\n                  " + _vm._s(part)), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (data.headerObj.gaps[index]),
            expression: "data.headerObj.gaps[index]"
          }],
          staticStyle: {
            "width": "500px"
          },
          attrs: {
            "placeholder": "Enter text for header"
          },
          domProps: {
            "value": (data.headerObj.gaps[index])
          },
          on: {
            "keyup": _vm.trimMoreThan4Spaces,
            "blur": _vm.trimMoreThan4Spaces,
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(data.headerObj.gaps, index, $event.target.value)
            }
          }
        })])
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.headerObj.last))])], 2) : _vm._e(), _vm._v(" "), (data.turn_template_data && data.turn_template_data.BODY) ? _c('div', {
        staticClass: "nudge-whatsapp-body"
      }, [_vm._l((data.bodyObj.text), function(part, index) {
        return _c('span', {
          key: 'body' + index,
          staticStyle: {
            "white-space": "pre-wrap"
          }
        }, [_vm._v(_vm._s(part)), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (data.bodyObj.gaps[index]),
            expression: "data.bodyObj.gaps[index]"
          }],
          staticStyle: {
            "margin-bottom": "4px",
            "width": "500px"
          },
          attrs: {
            "placeholder": "Enter text for body"
          },
          domProps: {
            "value": (data.bodyObj.gaps[index])
          },
          on: {
            "keyup": _vm.trimMoreThan4Spaces,
            "blur": _vm.trimMoreThan4Spaces,
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(data.bodyObj.gaps, index, $event.target.value)
            }
          }
        })])
      }), _c('span', [_vm._v(_vm._s(data.bodyObj.last))])], 2) : _vm._e(), _vm._v(" "), (data.turn_template_data && data.turn_template_data.FOOTER) ? _c('div', {
        staticClass: "nudge-whatsapp-footer"
      }, [_vm._v(_vm._s(data.turn_template_data.FOOTER))]) : _vm._e(), _vm._v(" "), (data.turn_template_data && data.turn_template_data.BUTTONS) ? _c('div', {
        staticStyle: {
          "margin-top": "5px"
        }
      }, _vm._l((data.buttonsObj), function(button, bIndex) {
        return _c('div', {
          key: 'button' + bIndex,
          staticClass: "nudge-whatsapp-button"
        }, [(button.text.length) ? [_vm._l((button.text), function(part, index) {
          return _c('span', {
            key: 'buttonPart' + index
          }, [_vm._v("\n                      " + _vm._s(part)), _c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (button.gaps[index]),
              expression: "button.gaps[index]"
            }],
            staticStyle: {
              "width": "300px"
            },
            attrs: {
              "placeholder": "Enter value for button link"
            },
            domProps: {
              "value": (button.gaps[index])
            },
            on: {
              "keyup": _vm.trimMoreThan4Spaces,
              "blur": _vm.trimMoreThan4Spaces,
              "input": function($event) {
                if ($event.target.composing) { return; }
                _vm.$set(button.gaps, index, $event.target.value)
              }
            }
          })])
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(button.last))])] : [_vm._v(_vm._s(button.label))]], 2)
      }), 0) : _vm._e(), _vm._v(" "), (!data.turn_template_data) ? _c('div', {
        staticClass: "nudge-whatsapp-body"
      }, [_vm._v(" -- Not available in " + _vm._s(_vm.turnCountry) + " -- ")]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      staticClass: "nudge-origin-title",
      staticStyle: {
        "margin-top": "15px"
      }
    }, [_vm._v("Facebook Nudge(s):")]), _vm._v(" "), _vm._l((_vm.nudgePreviewData), function(data, index) {
      return _c('div', {
        key: index,
        staticClass: "margin-bottom-10px"
      }, [_c('span', {
        staticClass: "nudge-language"
      }, [_vm._v(_vm._s(data.language) + " :")]), _vm._v(" "), (data.fb_nudge_text) ? _c('div', {
        staticClass: "nudge-whatsapp-body"
      }, [_vm._v(_vm._s(data.fb_nudge_text))]) : _c('div', {
        staticClass: "nudge-whatsapp-body"
      }, [_vm._v(" -- No data available -- ")])])
    })], 2) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.turnCountry) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveConfiguredNudgeData
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeNudgePreview
    }
  }, [_vm._v("Close")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Configure Processing Function")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "collapsable-link-panel collapsable-link-panel-child-1",
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    },
    attrs: {
      "href": "#content-pf-description",
      "data-toggle": "collapse"
    }
  }, [_vm._v("Function Description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('hr')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('label', {
    attrs: {
      "for": "options"
    }
  }, [_vm._v("Semantic Message Set")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Language")]), _vm._v(" "), _c('th', [_vm._v("Text")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('label', {
    attrs: {
      "for": "options"
    }
  }, [_vm._v("Static Option Display Text")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Language")]), _vm._v(" "), _c('th', [_vm._v("Text")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modal-body",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('div', {
    staticClass: "style-section"
  }, [_c('div', [_vm._v("Whenever we are selecting the input type as Dynamic, a null_list option will be automatically generated.")]), _vm._v(" "), _c('div', [_vm._v("The end user would be redirected to the null_list configured stage in case the user does not have any referrals displayed to them.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modal-body",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('div', {
    staticClass: "style-section"
  }, [_c('div', [_vm._v("After checking this box, the user details will be stored in the provider_visits table when the user answers this question")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading padding-0"
  }, [_c('h3', {
    staticClass: "text-center panel-title"
  }, [_c('a', {
    staticClass: "collapsable-link-panel",
    attrs: {
      "href": "#content-stage-settings",
      "data-toggle": "collapse"
    }
  }, [_vm._v("\n            Stage Settings\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('span', {
    staticClass: "badge badge-warning"
  }, [_vm._v(" ------ Or/And ------ ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "data-toggle": "tooltip",
      "data-html": "true",
      "title": "Use this option to direct the user to a different stage in the event they enter an incorrect input"
    }
  }, [_vm._v("\n                            Failed "), _c('i', {
    staticClass: "fa fa-question-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('span', {
    staticClass: "badge badge-warning"
  }, [_vm._v(" ------ Or/And ------ ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-lg-3 col-sm-3 col-xs-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-6 col-sm-6 col-xs-6"
  }, [_c('label', [_vm._v("Option")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-6 col-sm-6 col-xs-6"
  }, [_c('label', [_vm._v("Action")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-lg-9 col-sm-9 col-xs-9"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-11 col-lg-11 col-sm-11 col-xs-11"
  }, [_c('label', [_vm._v("Methods")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
  }, [_vm._v(" ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-397f8acc","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/stage.vue
// module id = +Pa/
// module chunks = 1